
import { UserProfileKey } from '../../../types';

export const userProfile: Record<UserProfileKey, string> = {
  // Títulos principais
  myProfile: 'Meu Perfil',
  profileSubtitle: 'Gerencie suas informações pessoais, segurança e preferências da conta.',
  
  // Abas
  personal: 'Pessoal',
  security: 'Segurança',
  language: 'Idioma',
  
  // Seção Pessoal
  personalInfoTitle: 'Informações Pessoais',
  personalInfoSubtitle: 'Atualize seus dados de contato',
  fullName: 'Nome Completo',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  email: 'E-mail',
  phone: 'Telefone',
  company: 'Empresa (Opcional)',
  
  // Avatar
  changePhoto: 'Alterar foto',
  removePhoto: 'Remover foto',
  confirmRemovePhoto: 'Remover foto de perfil',
  confirmRemovePhotoDesc: 'Tem certeza que deseja remover sua foto de perfil? Esta ação não pode ser desfeita.',
  
  // Seção Segurança
  securityTitle: 'Senha de Acesso',
  securitySubtitle: 'Mantenha sua conta protegida',
  currentPassword: 'Senha Atual',
  newPassword: 'Nova Senha',
  confirmNewPassword: 'Confirmar Nova Senha',
  showPassword: 'Mostrar senha',
  hidePassword: 'Ocultar senha',
  
  // Validação de senha
  passwordStrength: 'Força da senha',
  passwordRequirements: 'Sua senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números',
  
  // Informações legadas
  personalInformation: 'Informações Pessoais',
  updatePersonalDetails: 'Atualize seus dados pessoais e avatar',
  updatePasswordSettings: 'Atualize sua senha e configurações de segurança',
  languageSettings: 'Configurações de Idioma',
  chooseLanguage: 'Escolha seu idioma preferido para o aplicativo',
  change: 'Alterar',
  remove: 'Remover',
  
  // Botões
  savePersonalInfo: 'Salvar Informações',
  changePassword: 'Alterar Senha',
  saveChanges: 'Salvar Alterações',
  updatePassword: 'Atualizar Senha',
  
  // Feedbacks
  successPersonalInfo: 'Informações atualizadas com sucesso',
  successPassword: 'Senha alterada com sucesso',
  errorGeneric: 'Não foi possível salvar. Tente novamente',
  errorCurrentPassword: 'Senha atual incorreta',
  passwordsDontMatch: 'As senhas não conferem',
};

